import { Typography } from '@libs/components';
import styled from 'styled-components';
import Bullets from '../bullets/Bullets';
type DotProps = {
  isPositive?: boolean;
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${({ theme }) => theme.borderRadius.x5};
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  box-shadow: ${({ theme }) => theme.shadows.sm};
  background-color: ${({ theme }) => theme.colors.surface.default};
  padding: 1.6rem 0;
  margin-bottom: 2.4rem;
  border-top: 1px solid ${({ theme }) => theme.colors.borders.default};
  ${({ theme }) => theme.media.tablet`
    padding:2.4rem 0 ;
    border:none;
    border-radius: ${theme.borderRadius.x6 as unknown as TemplateStringsArray};

  `}
`;
export const CustomImage = styled.img`
  width: 3.8rem;
  height: 3.8rem;
  object-fit: cover;
`;
export const Header = styled.div`
  padding: 0 1.6rem 0 1.6rem;
  ${({ theme }) => theme.media.tablet`
    padding: 0 2.4rem 1.9rem;
  `}
`;
export const Body = styled.div`
  padding: 0 1.6rem;
  ${({ theme }) => theme.media.tablet`
      padding:0 0 0 2.4rem;
  `};
`;
export const ListContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 7.6rem;
  padding: 0;
  ${({ theme }) => theme.media.tablet`
        padding: 0 2.4rem 0 0;
  `}
`;
export const Separator = styled.div`
  width: 100%;
  height: 0.1rem;
  background-color: ${({ theme }) => theme.colors.borders.default};
`;
export const ImageTitleContainer = styled.div`
  display: flex;
  align-items: center;
`;
export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 1.6rem;
`;
export const DescrContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 1rem;
  align-items: flex-end;
`;
export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4.2rem;
  height: 4.2rem;
`;

export const FlexCenter = styled.div`
  display: flex;
  align-items: center;
`;
export const TextSeparator = styled.div`
  padding: 0 0.2rem;
`;
export const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 0.4rem;
`;
export const Footer = styled.div`
  padding: 1.2rem 1.6rem 0;
  ${({ theme }) => theme.media.tablet`
         padding: 0.8rem 2.4rem 0; 

  `}
`;
export const DropDownArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 1.6rem;
  width: 2rem;
  height: 2rem;
`;
export const ListWrapper = styled.div`
  cursor: pointer;
  &:last-child {
    .separator {
      display: none;
    }
  }
`;
export const Dot = styled.div<DotProps>`
  background-color: ${({ theme, isPositive }) => {
    if (typeof isPositive === 'undefined') {
      return theme.colors.text.secondary;
    }
    return !isPositive ? theme.colors.text.critical : theme.colors.text.success;
  }};
  width: 0.5rem;
  height: 0.5rem;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  margin: 0 0.4rem;
`;
export const CustomTypography = styled(Typography)`
  display: flex;
  align-items: center;
  white-space: nowrap;
`;
export const GrayBullets = styled(Bullets)`
  background-color: ${({ theme }) => theme.colors.borders.default};
  width: 0.6rem;
  height: 0.6rem;
`;
export const CustomBullets = styled(Bullets)`
  margin-bottom: 1.2rem;
  width: 0.8rem;
  height: 0.8rem;
`;

export const DesktopTitle = styled(Typography)`
  display: none;

  ${({ theme }) => theme.media.tablet`
    display:block;
`}
`;
export const MobileTitle = styled(Typography)`
  display: block;

  ${({ theme }) => theme.media.tablet`
    display:none;
`}
`;
